import * as $ from 'jquery';
import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild, ViewEncapsulation, DoCheck, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { LoaderService } from '../../../services/infrastructure/loader.service';
import { LocalStorageService } from '../../../services/infrastructure/local-storage.service';
import { MasterConstants } from '../../../common/constants/master-constants';
import { CommonService } from '../../../services/common/common.service';
import { UserSecurityService } from '../../../services/common/user-security.service';
import { OTIOrderLandingFilterVM } from '../../../models/OTI/OTIOrderLandingFilterVM';
import { OtiService } from '../../../services/oti/oti.service';
import { CommandCenterService } from '../../../services/command-center/command-center.service';
import { DatePipe } from '@angular/common';
import { Subscription } from 'rxjs';
import { MatMenuTrigger } from '@angular/material/menu';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MatDateRangeInput } from '@angular/material/datepicker';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-oti-home-grid-view',
  templateUrl: './oti-home-grid-view.component.html',
  styleUrls: ['./oti-home-grid-view.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class OtiHomeGridViewComponent implements OnInit, OnDestroy, DoCheck {

  //ViewChild
  @ViewChild('otiOrdersTable', { read: MatSort }) otiOrdersSort: MatSort;
  @ViewChild('otiOrdersPaginator', { read: MatPaginator }) otiOrdersPaginator: MatPaginator;
  @ViewChild('menuTrigger') menu: MatMenuTrigger;
  @ViewChild('menuStatusTrigger') menuStatus: MatMenuTrigger;
  @ViewChild('dateRangeInput') dateRangeInput: MatDateRangeInput<Date>;

  subscription = new Array<Subscription>();
  otiOrdersDataSource: MatTableDataSource<any>;
  headerCompany = MasterConstants.US_COMPANYCODE;
  validateEvolveData: any;
  userMenuAccessList: any;
  dataCount = 0;
  otiOrdersList: any = [];
  chatAccess = false;
  orderColumns: string[] = ['webOrderNumber',
    'orderNumber',
    'productName',
    'vendor',
    'shipToLocation',
    'deliveredQty',
    'UOM',
    'orderStatus',
    'trackingURL'];


  seedOrderColumns: string[] = ['orderNumber',
    'customerPO',
    'orderDate',
    'itemDescription',
    'marketingBrand',
    'shipToLocation',
    'orderedQty',
    'deliveredQty',
    'orderStatus',
    'trackingURL'];

  filter: OTIOrderLandingFilterVM = new OTIOrderLandingFilterVM();
  cppFilters: OTIOrderLandingFilterVM = new OTIOrderLandingFilterVM();
  seedFilters: OTIOrderLandingFilterVM = new OTIOrderLandingFilterVM();
  selectedTabIndex = 0;
  isPickerOpen: boolean = false;
  isSeedOrderAccess = false;
  isCPPOrderAccess = false;
  maxOrderDate = new Date();
  minOrderDate = new Date();
  currentTab = 0;
  isLocalStorageSet: boolean = false;
  isInitialLoad: boolean = false;
  interval: any;
  @Output() dataLoadComplete = new EventEmitter<boolean>();
  shippedInTransitMessage: string = '';

  constructor(
    private router: Router,
    private localStorageService: LocalStorageService,
    private loaderService: LoaderService,
    private datePipe: DatePipe,
    private otiService: OtiService,
    private commonService: CommonService,
    private CommandCenterService: CommandCenterService,
    private userSecurityService: UserSecurityService) {

    this.isInitialLoad = true;
  }

  // page initilization code
  ngOnInit() {
    this.interval = setInterval(() => { this.setLocalStorage() }, 1000);
  }

  setLocalStorage() {
    if (!this.isLocalStorageSet) {
      if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
        this.isLocalStorageSet = true;
        clearInterval(this.interval);
        const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
        if (data !== null && data !== undefined && data.resultData.length > 0) {
          let headerCompanyCode = this.localStorageService.get(MasterConstants.HEADER_COMPANY_CODE)
          let userAccessByCompany = data.resultData.find(x => headerCompanyCode && x.userIdCompanyCode == JSON.parse(headerCompanyCode))
          const userMenuAccessList = userAccessByCompany == null ? [] : userAccessByCompany.userMenuAccessList;

          this.isSeedOrderAccess = this.commonService.checkUserRoleAccessTypeForMenu(userMenuAccessList, MasterConstants.FUNCTION_CODE.DEALER_ORDERS_TAB);
          this.isCPPOrderAccess = this.commonService.checkUserRoleAccessTypeForMenu(userMenuAccessList, MasterConstants.FUNCTION_CODE.CROP_PROTECTION_PRODUCT_ORDER);
          this.subscription.push(this.userSecurityService.getChatAccess().subscribe(results => {
            this.chatAccess = results.isChatActive;
          }));
          if (this.isSeedOrderAccess || this.isCPPOrderAccess) {
            // set min date for 19 months
            this.minOrderDate.setDate(this.maxOrderDate.getDate() - 580);
            this.setDefaultDateFilter();
          }
          else {
            this.dataLoadComplete.emit(true);
          }
        }
      }
    }
  }



  ngDoCheck() {
    var widthButtonDate = document.querySelector<HTMLElement>(".selectDateRange").offsetWidth;
    var elems = Array.from(document.getElementsByClassName('dropdown-content-new') as HTMLCollectionOf<HTMLElement>);
    for (var i = 0; i < elems.length; i++) {
      elems[i].style.width = widthButtonDate + 40 + "px";
    }
  }

  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setHeight();
    this.setSeedOrdersTableHeight();
  }

  ngAfterViewInit() {
    this.setHeight();
    this.setSeedOrdersTableHeight();
  }

  // Tab changed
  tabChanged = (tabChangeEvent: MatTabChangeEvent): void => {
    this.filter.paginatorSize = this.otiOrdersPaginator.pageSize;

    if (this.selectedTabIndex === 0 && this.selectedTabIndex !== tabChangeEvent.index) {
      this.cppFilters = this.filter;
      this.filter = this.seedFilters;
      this.otiOrdersPaginator.pageSize = this.filter.paginatorSize;
    }
    else if (this.selectedTabIndex === 1 && this.selectedTabIndex !== tabChangeEvent.index) {
      this.seedFilters = this.filter;
      this.filter = this.cppFilters;
      this.otiOrdersPaginator.pageSize = this.filter.paginatorSize;
    }
    this.dateRangeInput._startInput.value = this.filter.fromOrderDate !== null ? new Date(this.filter.fromOrderDate) : null;
    this.dateRangeInput._endInput.value = this.filter.toOrderDate !== null ? new Date(this.filter.toOrderDate) : null;
    this.selectedTabIndex = tabChangeEvent.index;
    this.setHeight();
    this.setSeedOrdersTableHeight();
    if (!this.isInitialLoad)
    this.getOtiOrders();
  };

  setHeight() {
    const templateHeight = window.innerHeight - $('.mat-mdc-tab-header').outerHeight() - $('.order-top-sec').outerHeight() - 95;
    $('.dealertableContainer').css('max-height', templateHeight + 'px');
    $('.dealertableContainer').css('min-height', templateHeight + 'px');
  }

  setSeedOrdersTableHeight() {
    const templateHeight = window.innerHeight - $('.mat-mdc-tab-header').outerHeight() - $('.order-top-sec').outerHeight() - 95;
    $('.seedOrdersTable').css('max-height', templateHeight + 'px');
    $('.seedOrdersTable').css('min-height', templateHeight + 'px');
  }


  setDefaultDateFilter() {
    //this.loaderService.setLoaderStatus(true);
    this.defaultPageFilter();
    this.getOtiOrders();
  }

  // set Default Page Filter
  defaultPageFilter() {

    this.filter = {
      'account': null,
      'dateInDays': 90,
      'fromOrderDate': null,
      'toOrderDate': null,
      'salesOrderNumber': null,
      'customerPO': null,
      'orderStatus': "Shipped In Transit",
      'productLineSegment': (this.isCPPOrderAccess && this.isSeedOrderAccess) || this.isCPPOrderAccess ? 'CPP' : 'SEED',
      'searchText': '',
      'dateRangeText': 'Last 90 days',
      'orderStatusText': "Shipped In Transit",
      'paginatorSize': 20
    };
    this.cppFilters = Object.assign({}, this.filter);
    this.seedFilters = Object.assign({}, this.filter);
    this.seedFilters.productLineSegment = 'SEED';
  }

  // get list of orders based on filter
  getOtiOrders() {
    this.loaderService.setLoaderStatus(true);
    this.dataLoadComplete.emit(false);
    const payload = {
      'account': this.filter.account,
      'dateInDays': this.filter.dateInDays,
      'fromOrderDate': this.filter.fromOrderDate,
      'toOrderDate': this.filter.toOrderDate,
      'salesOrderNumber': this.filter.salesOrderNumber,
      'customerPO': this.filter.customerPO,
      'orderStatus': this.filter.orderStatus,
      'productLineSegment': this.filter.productLineSegment
    };
    if (this.filter.productLineSegment === 'CPP') {
      this.loadApi(this.CommandCenterService.getCommandCenterCppData(payload));
    } else {
      this.loadApi(this.CommandCenterService.getCommandCenterSeedData(payload));
    }
  }

  navigatetoViewOrderWithFilters() {
    this.otiService.setFilters(this.filter);
    this.router.navigate(['/order/dashboard']);
  }

  loadApi(serviceCall: Observable<any>) {
    this.subscription.push(
      serviceCall.subscribe(
        (result: any) => {
          let orders = result;
          if (result && result.resultData) {
            orders = result.resultData;
            this.shippedInTransitMessage = result.message;
          }
          this.otiOrdersList = orders;
          this.otiOrdersDataSource = new MatTableDataSource(orders);
          this.dataCount = orders.length;
          this.otiOrdersDataSource.paginator = this.otiOrdersPaginator;
          this.otiOrdersDataSource.paginator.firstPage();
          this.otiOrdersDataSource.sort = this.otiOrdersSort;
          this.setHeight();
          this.setSeedOrdersTableHeight();
          this.dataLoadComplete.emit(true);
          if (!this.isInitialLoad) {
            this.loaderService.setLoaderStatus(false);
          }
          this.isInitialLoad = false;
        },
        error => {
          this.dataLoadComplete.emit(true);
          this.loaderService.setLoaderStatus(false);
        }
      )
    );
  }

  setDateFilter(id, text, days, event) {
    if (id == 2) {
      this.filter.dateInDays = 0;
      if (event.value) {
        this.filter.fromOrderDate = new Date(event.value).toDateString();
      }
    }
    else if (id == 3) {
      this.filter.dateInDays = 0;
      if (event.value) {
        this.filter.toOrderDate = new Date(event.value).toDateString();
      }
    }
    else if (id == 4 || days > 0) {
      this.filter.dateInDays = 0;
      this.filter.fromOrderDate = null;
      this.filter.toOrderDate = null;
      this.filter.dateRangeText = ''

      this.dateRangeInput._startInput.value = null;
      this.dateRangeInput._endInput.value = null;
    }
    this.filter.dateInDays = days;
    this.filter.dateRangeText = text;
    if ((this.filter.fromOrderDate != null && this.filter.toOrderDate != null) || this.filter.dateInDays > 0) {
      this.filter.dateRangeText = this.filter.dateInDays <= 0 ? this.datePipe.transform(this.filter.fromOrderDate, 'MM/dd/yyyy')
        + ' - ' + this.datePipe.transform(this.filter.toOrderDate, 'MM/dd/yyyy')
        : this.filter.dateRangeText;
      this.menu.closeMenu();
      this.getOtiOrders();
    }
  }

  onPickerClosed() {
    this.isPickerOpen = false;
  }

  ngOnDestroy() {
    this.subscription.forEach(sub => sub.unsubscribe());
  }
}
